<header class="mobile-header" [class.hidden]="!isVisible()">
  <img src="assets/images/shiftat-logo-small.svg" alt="Shiftat" class="mobile-header-logo" />
  <div class="mobile-header-spacer"></div>
  <button class="mobile-header-btn" (click)="toggleTheme()">
    <mat-icon [fontSet]="themeIcon().fontSet" [fontIcon]="themeIcon().fontIcon"></mat-icon>
  </button>
  @if (showHamburger()) {
    <button class="mobile-header-hamburger" (click)="hamburgerClick.emit()">
      <mat-icon fontSet="uicon-rr" fontIcon="fi-rr-menu-burger"></mat-icon>
    </button>
  }
</header>
